import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { formatCurrency } from '@utils/formatters';

const CashFlowChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-gray-500">
        Sem dados para exibir
      </div>
    );
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
          <p className="font-medium text-gray-900 dark:text-white mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: {formatCurrency(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis 
          dataKey="monthLabel" 
          stroke="#9ca3af"
          fontSize={12}
        />
        <YAxis 
          tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
          stroke="#9ca3af"
          fontSize={12}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend />
        <Bar dataKey="projectedIncome" name="Receita Prevista" fill="#22c55e" radius={[4, 4, 0, 0]} />
        <Bar dataKey="projectedExpense" name="Despesa Prevista" fill="#ef4444" radius={[4, 4, 0, 0]} />
        <Line 
          type="monotone" 
          dataKey="projectedBalance" 
          name="Saldo Projetado" 
          stroke="#0ea5e9" 
          strokeWidth={3}
          dot={{ fill: '#0ea5e9', r: 4 }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default CashFlowChart;
